"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var idm_reporting_controls_1 = require("@synisys/idm-reporting-controls");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
require("rxjs/add/operator/debounceTime");
var report_view_styles_deserializer_1 = require("../common/model/style/report-view-styles-deserializer");
var columns_change_event_type_1 = require("../sis-tabular-report-designer/model/event/columns-change-event-type");
var report_model_parser_1 = require("../sis-tabular-report-designer/service/report-model.parser");
var report_view_styles_parser_1 = require("../sis-tabular-report-designer/service/report-view-styles.parser");
var view_event_service_1 = require("../sis-tabular-report-designer/service/view-event.service");
var reference_number_resolver_1 = require("./resolver/reference-number-resolver");
var view_element_branch_resolver_1 = require("./resolver/view-element-branch-resolver");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var rxjs_1 = require("rxjs");
var SisTabularReportOptionsComponent = /** @class */ (function () {
    function SisTabularReportOptionsComponent(viewEventService, datasetService, currentLanguageProvider, languageService, _changeDetectorRef, store, kbService, localeService) {
        var _this = this;
        this.viewEventService = viewEventService;
        this.datasetService = datasetService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.languageService = languageService;
        this._changeDetectorRef = _changeDetectorRef;
        this.store = store;
        this.kbService = kbService;
        this.localeService = localeService;
        this.ReportElementViewType = idm_report_export_service_client_js_1.ReportElementViewType;
        this.showCaption = false;
        this.showSuffix = false;
        this.showPrefix = false;
        this.showSorting = false;
        this.showTotal = false;
        this.showShowInGrantTotal = false;
        this.showShowInPercentage = false;
        this.showReference = false;
        this.showWidth = false;
        this.showDecimalPrecision = false;
        this.showConditionalFormatting = false;
        this.showCurrency = false;
        this.showViewOptions = true;
        this.isRowElementSelected = false;
        this.isColumnCategorySelected = false;
        this.isColumnMeasureSelected = false;
        this.isAnyElementSelected = false;
        this.datasetSelected = false;
        this.showRowNumberingCheckbox = false;
        this.isSerialNumberDisplay = null;
        /**
         * Dataset options to list from which to choose current dataset
         */
        this.datasetOptions = [];
        /**
         * Current dataSet id
         */
        this.dataSetId = null;
        this._reportTitle = null;
        this._subscriptions = [];
        this.defaultCurrencyId = null;
        this.isRowNumberingEnabled = false;
        this.viewState = new core_1.EventEmitter();
        this.datasetService.getDatasets().then(function (datasets) {
            _this.datasetOptions = Array.from(datasets.values());
        });
        this._subscriptions.push(this.kbService.getAllMetaCategories('reporting')
            .subscribe(function (metaCategories) {
            var map = new Map();
            if (metaCategories) {
                metaCategories.forEach(function (metaCategory) {
                    map.set(metaCategory.getSystemName(), metaCategory);
                });
            }
            _this.metaCategories = map;
        }));
        this._subscriptions.push(skynet_store_currencies_api_1.getDefaultCurrency(this.store)
            .subscribe(function (currencyModel) {
            _this.defaultCurrencyId = currencyModel.id;
        }));
        this._subscriptions.push(this.viewEventService.reportChange$.subscribe(function (event) {
            _this._reportTableView = event.reportTableView;
            _this.recalculateColumnRootDto(_this._reportTableView);
            _this.recalculateReferenceNumbers();
            _this.stateChanged();
        }));
        var localeInfoObservable = this.currentLanguageProvider.getCurrentLanguage().switchMap(function (language) {
            _this.currentLanguage = language;
            return rxjs_1.Observable.fromPromise(localeService.getLocaleInfo(language.getId()));
        });
        this._subscriptions.push(rxjs_1.Observable.combineLatest(localeInfoObservable, this.viewEventService.reportSetup$).subscribe(function (_a) {
            var localeInfo = _a[0], event = _a[1];
            _this._reportTableView = event.reportTableView;
            _this.recalculateColumnRootDto(_this._reportTableView);
            _this.recalculateReferenceNumbers();
            _this.initSelectedElement(_this._rowView, _this._columnView, _this._pathHolder, localeInfo);
        }));
        this._subscriptions.push(rxjs_1.Observable.combineLatest(localeInfoObservable, this.viewEventService.rowElementSelected$).subscribe(function (_a) {
            var localeInfo = _a[0], data = _a[1];
            _this.initSelectedElement(data.rowView, null, data.pathHolder, localeInfo);
        }));
        this._subscriptions.push(rxjs_1.Observable.combineLatest(localeInfoObservable, this.viewEventService.columnElementSelected$).subscribe(function (_a) {
            var localeInfo = _a[0], data = _a[1];
            _this.initSelectedElement(null, data.columnView, data.pathHolder, localeInfo);
        }));
        this._subscriptions.push(this.languageService.getAvailableLanguages().subscribe(function (languages) {
            _this.languages = languages;
        }));
        this._subscriptions.push(this.viewEventService.columnsChange$.filter(function (event) {
            return event.type === columns_change_event_type_1.ColumnsChangeEventType.COLUMN_ADDED || event.type === columns_change_event_type_1.ColumnsChangeEventType.COLUMN_REMOVED ||
                event.type === columns_change_event_type_1.ColumnsChangeEventType.COLUMN_MOVED || event.type === columns_change_event_type_1.ColumnsChangeEventType.TEMP_COLUMNS_ADDED;
        }).subscribe(function (event) {
            _this.reassignRowFormattingConditionsMeasureBranchIndexes(_this._reportTableView.rows.rows, event.branchIndexesDif);
            _this.reassignColumnFormattingConditionsMeasureBranchIndexes(_this._reportTableView.columns.children, event.branchIndexesDif);
        }));
    }
    SisTabularReportOptionsComponent_1 = SisTabularReportOptionsComponent;
    SisTabularReportOptionsComponent.getFontByName = function (fontName) {
        switch (fontName.toLowerCase()) {
            case 'arial':
                return idm_report_export_service_client_js_1.FontName.ARIAL;
            case 'tahoma':
                return idm_report_export_service_client_js_1.FontName.TAHOMA;
            case 'verdana':
                return idm_report_export_service_client_js_1.FontName.VERDANA;
            case 'times new roman':
                return idm_report_export_service_client_js_1.FontName.TIMES_NEW_ROMAN;
        }
    };
    SisTabularReportOptionsComponent.getAlignByName = function (alignName) {
        switch (alignName) {
            case 'left':
                return idm_report_export_service_client_js_1.Align.LEFT;
            case 'center':
                return idm_report_export_service_client_js_1.Align.CENTER;
            case 'right':
                return idm_report_export_service_client_js_1.Align.RIGHT;
        }
    };
    SisTabularReportOptionsComponent.convertFontStyleToTextStyle = function (fontStyle) {
        var textStyle = new idm_report_export_service_client_js_1.TextStyleDto();
        textStyle.align = SisTabularReportOptionsComponent_1.getAlignByName(fontStyle.align);
        textStyle.backgroundColor = fontStyle.backgroundColor;
        textStyle.color = fontStyle.color;
        textStyle.fontName = fontStyle.fontName && SisTabularReportOptionsComponent_1.getFontByName(fontStyle.fontName);
        textStyle.fontSize = fontStyle.fontSize;
        textStyle.isBold = fontStyle.isBold;
        textStyle.isItalic = fontStyle.isItalic;
        textStyle.isUnderline = fontStyle.isUnderline;
        return textStyle;
    };
    SisTabularReportOptionsComponent.prototype.ngOnChanges = function (changes) {
        if (changes && changes['fullState']) {
            this.extractReportJson();
        }
    };
    SisTabularReportOptionsComponent.prototype.ngOnDestroy = function () {
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    Object.defineProperty(SisTabularReportOptionsComponent.prototype, "reportTitle", {
        get: function () {
            return this._reportTitle;
        },
        set: function (value) {
            this._reportTitle = value;
            this.additionalOptionsChanged = true;
            this.stateChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTabularReportOptionsComponent.prototype, "exportHeader", {
        get: function () {
            return this.header && this.header.text;
        },
        set: function (value) {
            this.header.text = value;
            this.stateChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTabularReportOptionsComponent.prototype, "exportFooter", {
        get: function () {
            return this.footer && this.footer.text;
        },
        set: function (value) {
            this.footer.text = value;
            this.stateChanged();
        },
        enumerable: true,
        configurable: true
    });
    SisTabularReportOptionsComponent.prototype.onDatasetChange = function (dataSetId) {
        this.applyEnabled = true;
        this.dataSetId = dataSetId;
    };
    SisTabularReportOptionsComponent.prototype.onHeaderEnableChange = function (enable) {
        this.header = enable ? new idm_report_export_service_client_js_1.MultilingualStyledTextDto(new Map(), null) : null;
    };
    SisTabularReportOptionsComponent.prototype.onHeaderStylesChange = function (fontStyle) {
        this.header.textStyle = SisTabularReportOptionsComponent_1.convertFontStyleToTextStyle(fontStyle);
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onFooterEnableChange = function (enable) {
        this.footer = enable ? new idm_report_export_service_client_js_1.MultilingualStyledTextDto(new Map(), null) : null;
    };
    SisTabularReportOptionsComponent.prototype.onFooterStylesChange = function (fontStyle) {
        this.footer.textStyle = SisTabularReportOptionsComponent_1.convertFontStyleToTextStyle(fontStyle);
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onFooterPageNumbersChange = function (showFooterPageNumbers) {
        this.showPageNumberOnFooter = showFooterPageNumbers;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onSuffixChange = function (newValue) {
        this._selectedElementMeasureValueFormat.suffixText = newValue;
        this.suffix = newValue;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onPrefixChange = function (newValue) {
        this._selectedElementMeasureValueFormat.prefixText = newValue;
        this.prefix = newValue;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onCaptionChange = function (newValue) {
        this._selectedElementStyleDto.alias = newValue;
        this.caption = newValue;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onShowTotalChange = function (selected) {
        var totalType;
        switch (selected) {
            case idm_reporting_service_client_js_1.TotalType.NONE:
                totalType = idm_reporting_service_client_js_1.TotalType.NONE;
                break;
            case idm_reporting_service_client_js_1.TotalType.AFTER:
                totalType = idm_reporting_service_client_js_1.TotalType.AFTER;
                break;
            case idm_reporting_service_client_js_1.TotalType.BEFORE:
                totalType = idm_reporting_service_client_js_1.TotalType.BEFORE;
                break;
            default:
                throw new Error("Unknown total type : " + totalType + " ");
        }
        if (this._isCategory) {
            this._selectedCategoryItemCategoryElementDto.totalType = totalType;
        }
        this.totalType = totalType;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onShowInGrantTotalChange = function (checked) {
        this._columnView.element.showOnRowsTotal = checked;
        this.showInGrantTotal = checked;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onHideUnspecifiedChange = function (checked) {
        this.reportOptions.hideUnspecifiedRowHierarchy = checked;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onShowInPercentageChange = function (checked) {
        this._selectedElementMeasureValueFormat.isShowInPercentage = checked;
        if (this.isColumnMeasureSelected) {
            this._columnView.element.isShowInPercentage = checked;
        }
        this.showInPercentage = checked;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onSortingChange = function (sorting) {
        var orderType;
        switch (sorting) {
            case idm_reporting_service_client_js_1.OrderType.NONE:
                orderType = idm_reporting_service_client_js_1.OrderType.NONE;
                break;
            case idm_reporting_service_client_js_1.OrderType.ASCENDING:
                orderType = idm_reporting_service_client_js_1.OrderType.ASCENDING;
                break;
            case idm_reporting_service_client_js_1.OrderType.DESCENDING:
                orderType = idm_reporting_service_client_js_1.OrderType.DESCENDING;
                break;
            default:
                throw new Error("Unknown sorting type : " + sorting + " ");
        }
        this.element.orderType = orderType;
        this.sorting = orderType;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onReferenceChange = function (newValue) {
        if (newValue.getValue(this.currentLanguage.getId()) === '') {
            this._selectedElementStyleDto.reference = null;
            this.referenceText = null;
            this._referenceNumber = null;
            this.recalculateReferenceNumbers();
        }
        else {
            var refText = newValue;
            this.referenceText = newValue;
            var refNumber_1 = new Map();
            var nextReferenceNumber_1;
            if (!this._selectedElementStyleDto.reference) {
                nextReferenceNumber_1 = reference_number_resolver_1.ReferenceNumberResolver.getNextReferenceNumber(this._reportTableView);
            }
            else {
                nextReferenceNumber_1 = this._selectedElementStyleDto.reference.referenceNumber.text.getValue(this.currentLanguage.getId());
            }
            this.languages.forEach(function (language) {
                refNumber_1.set(language.getId(), nextReferenceNumber_1.toString());
            });
            this._referenceNumber = new idm_crosscutting_concepts_frontend_1.MultilingualString(refNumber_1);
            this._selectedElementStyleDto.reference =
                new idm_report_export_service_client_js_1.ReferenceDto(new idm_report_export_service_client_js_1.MultilingualStyledTextDto(refNumber_1, null), new idm_report_export_service_client_js_1.MultilingualStyledTextDto(refText, null));
        }
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onWidthChange = function (newWidth) {
        this._selectedElementStyleDto.width = newWidth;
        this.width = newWidth;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onViewOptionChange = function (viewOption) {
        this._selectedElementStyleDto.view = viewOption;
        this.viewOption = viewOption;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.checkIsNumber = function (event) {
        return event.ctrlKey || event.altKey
            || (47 < event.keyCode && event.keyCode < 58 && event.shiftKey === false)
            || (95 < event.keyCode && event.keyCode < 106)
            || (event.keyCode === 8) || (event.keyCode === 9)
            || (event.keyCode > 34 && event.keyCode < 40)
            || (event.keyCode === 46);
    };
    SisTabularReportOptionsComponent.prototype.onDecimalPrecisionChange = function (selectedValue) {
        var pattern = '#,##0';
        if (selectedValue > 0) {
            pattern += '.';
            for (var i = 0; i < selectedValue; i++) {
                pattern += '0';
            }
        }
        this.decimalPrecision = selectedValue;
        if (this.isColumnMeasureSelected) {
            this._selectedElementMeasureValueFormat.formattingPattern = pattern;
            this.stateChanged();
        }
    };
    SisTabularReportOptionsComponent.prototype.onCurrencyChange = function (currencyId) {
        this.element.currencyId = currencyId;
        this.currency = currencyId;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.onRowNumberingOptionChange = function (isRowNumberingEnabled) {
        var numberingStyle = isRowNumberingEnabled ? new idm_report_export_service_client_js_1.NumberingStyleDto() : null;
        this._rowView.rowCategoryStyleDto.numberingStyle = numberingStyle;
        this.stateChanged();
    };
    SisTabularReportOptionsComponent.prototype.stateChanged = function () {
        this.applyEnabled = true;
        this.viewEventService.styleChanged();
        this.createAndEmitFullState();
    };
    SisTabularReportOptionsComponent.prototype.close = function () {
        this.clean();
    };
    SisTabularReportOptionsComponent.prototype.clean = function () {
        this.cleanSelectedElement();
    };
    SisTabularReportOptionsComponent.prototype.apply = function () {
        this.applyEnabled = false;
        if (this.datasetSelected) {
            this.viewEventService.styleChanged();
            this.viewEventService.notifyPageBuilder();
            this.viewEventService.resetElementSelection();
        }
        else {
            this.viewState.emit({
                state: {
                    report: new idm_reporting_service_client_js_1.ReportDtoBuilder().build(),
                    filters: idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder().build(),
                    pagingCriteria: idm_reporting_service_client_js_1.PagingCriteria.all(),
                    reportOptions: new idm_reporting_service_client_js_1.ReportOptions(),
                },
                dataSetId: this.dataSetId,
                title: this.reportTitle ? idm_reporting_controls_1.MultilingualTypeHelper.serializeMultilingualString(this.reportTitle) : ''
            });
        }
    };
    SisTabularReportOptionsComponent.prototype.cleanSelectedElement = function () {
        this.showCaption = false;
        this.showSuffix = false;
        this.showPrefix = false;
        this.showSorting = false;
        this.showCurrency = false;
        this.showTotal = false;
        this.showShowInGrantTotal = false;
        this.showShowInPercentage = false;
        this.showReference = false;
        this.showWidth = false;
        this.showDecimalPrecision = false;
        this.showConditionalFormatting = false;
        this.showViewOptions = false;
        this._columnView = null;
        this._rowView = null;
        this.element = null;
        this._isMeasure = false;
        this._isCategory = false;
        this.isRowElementSelected = false;
        this.isColumnMeasureSelected = false;
        this.isColumnCategorySelected = false;
        this.isAnyElementSelected = false;
        this.selectedMeasurePathHolderId = null;
        this._selectedElementStyleDto = null;
        this._selectedCategoryItemCategoryElementDto = null;
        this.selectedColumnFormattingRule = null;
        this.selectedRowFormattingRule = null;
        this.selectedMeasureElementBranchIndex = null;
        this._selectedElementMeasureValueFormat = null;
        this.caption = null;
        this.suffix = null;
        this.prefix = null;
        this.decimalPrecision = null;
        this.width = null;
        this.sorting = null;
        this.currency = null;
        this.totalType = null;
        this.showInGrantTotal = null;
        this.showInPercentage = null;
        this._referenceNumber = null;
        this.referenceText = null;
        this.viewOption = null;
        this.showRowNumberingCheckbox = false;
    };
    SisTabularReportOptionsComponent.prototype.initSelectedElement = function (rowView, columnView, pathHolder, localeInfo) {
        this.cleanSelectedElement();
        this._columnView = columnView;
        this._rowView = rowView;
        this._pathHolder = pathHolder;
        this.element = rowView ? rowView.element : (columnView ? columnView.element : null);
        this._isMeasure = this.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto;
        this._isCategory = this.element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto || this.element instanceof idm_reporting_service_client_js_1.RowCategoryDto;
        this.isRowElementSelected = this._rowView !== undefined && this._rowView !== null;
        this.isColumnMeasureSelected = this._columnView !== undefined && this._columnView !== null && this._isMeasure;
        this.isColumnCategorySelected = this._columnView !== undefined && this._columnView !== null && this._isCategory;
        this.isAnyElementSelected = this.isRowElementSelected || this.isColumnMeasureSelected || this.isColumnCategorySelected;
        this.localeInfo = localeInfo;
        this.obtainSelectedMeasurePathHolderId();
        this.obtainSelectedElementStyleDto();
        this.obtainSelectedCategoryItemCategoryElementDto();
        this.obtainSelectedColumnFormattingRule();
        this.obtainSelectedRowFormattingRule();
        this.obtainSelectedMeasureElementBranchIndex();
        this.obtainSelectedElementMeasureValueFormat();
        if (this.isRowElementSelected) {
            this.enableRowCategoryStyles();
        }
        else if (this.isColumnCategorySelected) {
            this.enableColumnCategoryStyles();
        }
        else if (this.isColumnMeasureSelected) {
            var measurePathType = this._pathHolder.measurePathType;
            switch (measurePathType) {
                case idm_dataset_service_client_js_1.MeasurePathType.NUMBER:
                    this.enableNumberMeasureStyles();
                    break;
                case idm_dataset_service_client_js_1.MeasurePathType.MONEY:
                    this.obtainSelectedElementCurrency();
                    this.enableMoneyMeasureStyles();
                    break;
                case idm_dataset_service_client_js_1.MeasurePathType.DATE:
                case idm_dataset_service_client_js_1.MeasurePathType.DATETIME:
                    this.enableDateMeasureStyles();
                    break;
                case idm_dataset_service_client_js_1.MeasurePathType.TEXT:
                case idm_dataset_service_client_js_1.MeasurePathType.BOOLEAN:
                    this.enableTextMeasureStyles();
                    break;
                default:
                    throw new Error("Unknown measure type: " + measurePathType);
            }
        }
        this.obtainSelectedElementCaption();
        this.obtainSelectedElementReferenceText();
        this.obtainSelectedElementWidth();
        this.obtainSelectedElementViewOption();
        this.obtainSelectedElementDecimalPrecision(localeInfo);
        this.obtainSelectedElementSorting();
        this.obtainSelectedElementTotalType();
        this.obtainSelectedElementTextStyle();
        this.obtainSelectedElementShowInGrantTotal();
        this.obtainSelectedElementShowInPercentage();
        this.obtainSelectedElementSuffix();
        this.obtainSelectedElementPrefix();
        this.obtainSelectedRowNumberingEnabled();
    };
    /**
     * Following methods enable style attributes' flags
     * */
    SisTabularReportOptionsComponent.prototype.enableRowCategoryStyles = function () {
        this.showCaption = true;
        this.showTotal = true;
        this.showSorting = true;
        this.showReference = true;
        this.showWidth = true;
        this.showRowNumberingCheckbox = true;
        this.enableCategoryViewStyle();
    };
    SisTabularReportOptionsComponent.prototype.enableMoneyMeasureStyles = function () {
        this.showCaption = true;
        this.showPrefix = true;
        this.showSuffix = true;
        this.showShowInGrantTotal = true;
        this.showShowInPercentage = true;
        this.showSorting = true;
        this.showReference = true;
        this.showWidth = true;
        this.showDecimalPrecision = true;
        this.showConditionalFormatting = true;
        this.showCurrency = true;
    };
    SisTabularReportOptionsComponent.prototype.enableNumberMeasureStyles = function () {
        this.showCaption = true;
        this.showPrefix = true;
        this.showSuffix = true;
        this.showShowInGrantTotal = true;
        this.showShowInPercentage = true;
        this.showSorting = true;
        this.showReference = true;
        this.showWidth = true;
        this.showDecimalPrecision = true;
        this.showConditionalFormatting = true;
    };
    SisTabularReportOptionsComponent.prototype.enableTextMeasureStyles = function () {
        this.showCaption = true;
        this.showPrefix = true;
        this.showSuffix = true;
        this.showShowInGrantTotal = true;
        this.showSorting = true;
        this.showReference = true;
        this.showWidth = true;
        this.showConditionalFormatting = false;
    };
    SisTabularReportOptionsComponent.prototype.enableDateMeasureStyles = function () {
        this.showCaption = true;
        this.showPrefix = true;
        this.showSuffix = true;
        this.showShowInGrantTotal = true;
        this.showSorting = true;
        this.showReference = true;
        this.showWidth = true;
        this.showConditionalFormatting = false;
    };
    SisTabularReportOptionsComponent.prototype.enableColumnCategoryStyles = function () {
        this.showCaption = true;
        this.showTotal = true;
        if (this.isLastCategoryInBranch() && !this.existsMeasureInBranch()) {
            this.showShowInGrantTotal = true;
            this.enableCategoryViewStyle();
        }
        this.showSorting = true;
        this.showReference = true;
        this.showWidth = true;
        this.showConditionalFormatting = false;
    };
    /**
     * Shows category view options when selected category has icon
     */
    SisTabularReportOptionsComponent.prototype.enableCategoryViewStyle = function () {
        if (this.metaCategories) {
            var metaCategorySystemName = this._pathHolder.metaCategoryId.systemName;
            var metaCategory = this.metaCategories.get(metaCategorySystemName);
            if (metaCategory && metaCategory.getHasIcon()) {
                (this.showViewOptions = true);
            }
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedMeasurePathHolderId = function () {
        if (this.isColumnMeasureSelected) {
            this.selectedMeasurePathHolderId = this._columnView.element.measurePathHolderId;
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementStyleDto = function () {
        if (this.isRowElementSelected) {
            this._selectedElementStyleDto = this._rowView.rowCategoryStyleDto;
        }
        else if (this.isColumnCategorySelected || this.isColumnMeasureSelected) {
            this._selectedElementStyleDto = this._columnView.columnStyleDto;
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedCategoryItemCategoryElementDto = function () {
        if (this.isRowElementSelected) {
            this._selectedCategoryItemCategoryElementDto = this._rowView.element.categoryElementDto;
        }
        else if (this.isColumnCategorySelected) {
            var element = this._columnView.element;
            this._selectedCategoryItemCategoryElementDto = element.categoryElementDto;
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedColumnFormattingRule = function () {
        if (this._selectedElementStyleDto) {
            var selectedColumnStyleDto = this._selectedElementStyleDto;
            if (selectedColumnStyleDto instanceof idm_report_export_service_client_js_1.ColumnMeasureStyleDto) {
                this.selectedColumnFormattingRule = selectedColumnStyleDto.columnFormattingRule;
            }
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedRowFormattingRule = function () {
        if (this._selectedElementStyleDto) {
            var selectedColumnStyleDto = this._selectedElementStyleDto;
            if (selectedColumnStyleDto instanceof idm_report_export_service_client_js_1.RowCategoryStyleDto) {
                this.selectedRowFormattingRule = selectedColumnStyleDto.rowFormattingRule;
            }
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedMeasureElementBranchIndex = function () {
        if (this._columnView) {
            this.selectedMeasureElementBranchIndex = view_element_branch_resolver_1.ViewElementBranchResolver.getColumnElementBranchIndex(this._columnView);
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementCaption = function () {
        if (this._selectedElementStyleDto) {
            var alias = this._selectedElementStyleDto.alias;
            if (alias !== undefined) {
                this.caption = alias;
            }
            else {
                this.caption = new idm_crosscutting_concepts_frontend_1.MultilingualString(this._pathHolder.name);
            }
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementSuffix = function () {
        if (this.isColumnMeasureSelected) {
            var columnMeasureStyleDto = this._columnView.columnStyleDto;
            var suffixText = void 0;
            if (columnMeasureStyleDto && columnMeasureStyleDto.measureValueFormat) {
                suffixText = columnMeasureStyleDto.measureValueFormat.suffixText;
            }
            if (suffixText !== undefined) {
                this.suffix = suffixText;
            }
            else {
                var values_1 = new Map();
                this.languages.forEach(function (language) {
                    values_1.set(language.getId(), '');
                });
                this.suffix = new idm_crosscutting_concepts_frontend_1.MultilingualString(values_1);
            }
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementPrefix = function () {
        if (this.isColumnMeasureSelected) {
            var columnMeasureStyleDto = this._columnView.columnStyleDto;
            var prefixText = void 0;
            if (columnMeasureStyleDto && columnMeasureStyleDto.measureValueFormat) {
                prefixText = columnMeasureStyleDto.measureValueFormat.prefixText;
            }
            if (prefixText !== undefined) {
                this.prefix = prefixText;
            }
            else {
                var values_2 = new Map();
                this.languages.forEach(function (language) {
                    values_2.set(language.getId(), '');
                });
                this.prefix = new idm_crosscutting_concepts_frontend_1.MultilingualString(values_2);
            }
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementWidth = function () {
        var style = this._selectedElementStyleDto;
        if (style && style.width !== undefined) {
            this.width = style.width;
        }
        else {
            this.width = null;
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementViewOption = function () {
        var style = this._selectedElementStyleDto;
        if (style) {
            if (this.showViewOptions) {
                if (style.view !== undefined) {
                    this.viewOption = style.view;
                }
                else {
                    style.view = this.viewOption = idm_report_export_service_client_js_1.ReportElementViewType.ONLY_VALUE;
                }
            }
            else {
                style.view = undefined;
            }
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementDecimalPrecision = function (localeInfo) {
        if (this.isColumnMeasureSelected) {
            var pattern = void 0;
            var columnMeasureStyleDto = this._columnView.columnStyleDto;
            if (columnMeasureStyleDto.measureValueFormat && columnMeasureStyleDto.measureValueFormat.formattingPattern) {
                pattern = columnMeasureStyleDto.measureValueFormat.formattingPattern;
            }
            if (pattern !== undefined) {
                var patternParts = pattern.split('.');
                this.decimalPrecision = patternParts.length > 1 ? patternParts[1].length : 0;
            }
            else {
                this.decimalPrecision = localeInfo.numberFormat.fractionDigits;
            }
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementSorting = function () {
        var selected = idm_reporting_service_client_js_1.OrderType.NONE;
        if (this.element && (this.element.orderType === idm_reporting_service_client_js_1.OrderType.DESCENDING
            || this.element.orderType === idm_reporting_service_client_js_1.OrderType.ASCENDING)) {
            selected = this.element.orderType;
        }
        this.sorting = selected;
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementCurrency = function () {
        if (this.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
            var measure = this.element;
            this.currency = measure.currencyId || this.defaultCurrencyId;
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementTotalType = function () {
        if (this._isCategory) {
            if (this._selectedCategoryItemCategoryElementDto.totalType !== undefined) {
                this.totalType = this._selectedCategoryItemCategoryElementDto.totalType;
            }
            else {
                this.totalType = idm_reporting_service_client_js_1.TotalType.NONE;
            }
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementShowInGrantTotal = function () {
        if (this.isColumnCategorySelected) {
            var categoryElement = this._columnView.element;
            this.showInGrantTotal = categoryElement.showOnRowsTotal;
        }
        if (this.isColumnMeasureSelected) {
            var measureElement = this._columnView.element;
            this.showInGrantTotal = measureElement.showOnRowsTotal;
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementShowInPercentage = function () {
        if (this.isColumnMeasureSelected) {
            this.showInPercentage = this._columnView.element.isShowInPercentage;
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementReferenceText = function () {
        if (this._selectedElementStyleDto) {
            var reference = this._selectedElementStyleDto.reference;
            if (reference !== undefined) {
                this.referenceText = reference.referenceText.text;
                this._referenceNumber = reference.referenceNumber.text;
            }
            else {
                var refText_1 = new Map();
                var refNumber_2 = new Map();
                this.languages.forEach(function (language) {
                    refText_1.set(language.getId(), '');
                    refNumber_2.set(language.getId(), '');
                });
                this.referenceText = new idm_crosscutting_concepts_frontend_1.MultilingualString(refText_1);
                this._referenceNumber = new idm_crosscutting_concepts_frontend_1.MultilingualString(refNumber_2);
            }
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementTextStyle = function () {
        if (this.isRowElementSelected) {
            if (this._rowView.rowCategoryStyleDto.valueStyle === undefined) {
                this._rowView.rowCategoryStyleDto.valueStyle = new idm_report_export_service_client_js_1.TextStyleDto();
            }
            this.selectedElementTextStyle = this._rowView.rowCategoryStyleDto.valueStyle;
        }
        else if (this.isColumnMeasureSelected || this.isColumnCategorySelected) {
            if (this._columnView.columnStyleDto.valueStyle === undefined) {
                this._columnView.columnStyleDto.valueStyle = new idm_report_export_service_client_js_1.TextStyleDto();
            }
            this.selectedElementTextStyle = this._columnView.columnStyleDto.valueStyle;
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedElementMeasureValueFormat = function () {
        if (this._columnView && this._columnView.columnStyleDto instanceof idm_report_export_service_client_js_1.ColumnMeasureStyleDto) {
            if (this._columnView.columnStyleDto.measureValueFormat === undefined) {
                this._columnView.columnStyleDto.measureValueFormat = new idm_report_export_service_client_js_1.MeasureValueFormatDto();
            }
            this._selectedElementMeasureValueFormat = this._columnView.columnStyleDto.measureValueFormat;
        }
    };
    SisTabularReportOptionsComponent.prototype.createAndEmitFullState = function () {
        if (this.additionalOptionsChanged) {
            this.applyAdditionalOptions();
            this.additionalOptionsChanged = false;
        }
        var fullState = {
            state: {
                report: report_model_parser_1.ReportModelParser.parse(this._reportTableView, this.defaultCurrencyId),
                filters: this.filterTreeDto,
                pagingCriteria: idm_reporting_service_client_js_1.PagingCriteria.all(),
                reportOptions: this.reportOptions,
                exportReportStyles: {
                    header: this.header && this.header.toJsonObject(),
                    footer: this.footer && this.footer.toJsonObject(),
                    showPageNumberOnFooter: this.showPageNumberOnFooter,
                    isSerialNumberDisplay: this.isSerialNumberDisplay
                },
                reportViewStyles: report_view_styles_parser_1.ReportViewStylesParser.parse(this._reportTableView).toJsonObject()
            },
            dataSetId: this.dataSetId,
            title: this._reportTitle ? idm_reporting_controls_1.MultilingualTypeHelper.serializeMultilingualString(this._reportTitle) : ''
        };
        this.viewState.emit(fullState);
    };
    /**
     * Extracts fields from full stat json
     */
    SisTabularReportOptionsComponent.prototype.extractReportJson = function () {
        if (this.fullState) {
            var jsonObject = typeof this.fullState === 'string' ? JSON.parse(this.fullState) : this.fullState;
            this._reportTitle = jsonObject.title ? idm_reporting_controls_1.MultilingualTypeHelper.deserializeMultilingualString(jsonObject.title) : null;
            this.dataSetId = jsonObject.dataSetId ? jsonObject.dataSetId : null;
            this.datasetSelected = this.dataSetId !== null;
            this.filterTreeDto = (jsonObject.state && jsonObject.state.filters) ? idm_reporting_service_client_js_1.FilterTreeDto.fromJson(JSON.stringify(jsonObject.state.filters))
                : idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder().build();
            this.reportOptions = (jsonObject.state && jsonObject.state.reportOptions) ? idm_reporting_service_client_js_1.ReportOptions.fromJson(JSON.stringify(jsonObject.state.reportOptions))
                : new idm_reporting_service_client_js_1.ReportOptions();
            if (jsonObject.state.exportReportStyles) {
                this.showPageNumberOnFooter = jsonObject.state.exportReportStyles.showPageNumberOnFooter;
                if (jsonObject.state.exportReportStyles.header) {
                    this.header = report_view_styles_deserializer_1.ReportViewStylesDeserializer.convertJsonToMultilingualStyledTextDto(jsonObject.state.exportReportStyles.header);
                }
                if (jsonObject.state.exportReportStyles.footer) {
                    this.footer = report_view_styles_deserializer_1.ReportViewStylesDeserializer.convertJsonToMultilingualStyledTextDto(jsonObject.state.exportReportStyles.footer);
                }
            }
        }
        else {
            this.filterTreeDto = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder().build();
            this.reportOptions = new idm_reporting_service_client_js_1.ReportOptions();
            this._reportTitle = null;
            this.dataSetId = null;
            this._dataSetName = new Map();
            this.datasetSelected = false;
        }
    };
    /**
     * Applies options that are editable(e.g. title, filters) during report design
     */
    SisTabularReportOptionsComponent.prototype.applyAdditionalOptions = function () {
        this.viewEventService.additionalOptionsChanged(this._reportTitle, this.dataSetId, this.filterTreeDto);
    };
    SisTabularReportOptionsComponent.prototype.recalculateReferenceNumbers = function () {
        reference_number_resolver_1.ReferenceNumberResolver.recalculateReferenceNumbers(this._reportTableView);
    };
    SisTabularReportOptionsComponent.prototype.recalculateColumnRootDto = function (reportTableView) {
        if (reportTableView) {
            this.columnRootDto = report_model_parser_1.ReportModelParser.parse(this._reportTableView, this.defaultCurrencyId).columnRootDto;
        }
    };
    /**
     * Checks whether selected category is the last one in branch
     * */
    SisTabularReportOptionsComponent.prototype.isLastCategoryInBranch = function () {
        return this._columnView.children.length === 0;
    };
    /**
     * Checks whether branch has measure or not
     * */
    SisTabularReportOptionsComponent.prototype.existsMeasureInBranch = function () {
        var hasMeasure = false;
        var current = this._columnView.parent;
        while (current.element) {
            if (this._columnView.parent.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                hasMeasure = true;
                break;
            }
            current = current.parent;
        }
        return hasMeasure;
    };
    SisTabularReportOptionsComponent.prototype.reassignRowFormattingConditionsMeasureBranchIndexes = function (rows, branchIndexesDif) {
        var _this = this;
        rows.forEach(function (row) {
            var newFormattingConditions = row.rowCategoryStyleDto.rowFormattingRule.getFormattingConditions();
            if (branchIndexesDif.size !== 0) {
                newFormattingConditions = newFormattingConditions.filter(function (condition) {
                    if (condition instanceof idm_report_export_service_client_js_1.ConstantFormattingConditionDto || condition instanceof idm_report_export_service_client_js_1.BetweenFormattingConditionDto) {
                        if (branchIndexesDif.has(condition.measureElementBranchIndex)) {
                            condition.measureElementBranchIndex = branchIndexesDif.get(condition.measureElementBranchIndex);
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else if (condition instanceof idm_report_export_service_client_js_1.MeasureToMeasureComparisonFormattingConditionDto) {
                        if (branchIndexesDif.has(condition.measureElement1BranchIndex) && branchIndexesDif.has(condition.measureElement2BranchIndex)) {
                            condition.measureElement1BranchIndex = branchIndexesDif.get(condition.measureElement1BranchIndex);
                            condition.measureElement2BranchIndex = branchIndexesDif.get(condition.measureElement2BranchIndex);
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        throw new Error('Unknown type of condition');
                    }
                });
                row.rowCategoryStyleDto.rowFormattingRule = new idm_report_export_service_client_js_1.RowFormattingRuleImpl(newFormattingConditions);
                _this.reassignRowFormattingConditionsMeasureBranchIndexes(row.children, branchIndexesDif);
            }
        });
    };
    SisTabularReportOptionsComponent.prototype.reassignColumnFormattingConditionsMeasureBranchIndexes = function (columns, branchIndexesDif) {
        var _this = this;
        columns.forEach(function (column) {
            if (column.element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                var newFormattingConditions = column.columnStyleDto.columnFormattingRule.getFormattingConditions();
                if (branchIndexesDif.size !== 0) {
                    newFormattingConditions = newFormattingConditions.filter(function (condition) {
                        if (condition instanceof idm_report_export_service_client_js_1.ConstantFormattingConditionDto || condition instanceof idm_report_export_service_client_js_1.BetweenFormattingConditionDto) {
                            if (branchIndexesDif.has(condition.measureElementBranchIndex)) {
                                condition.measureElementBranchIndex = branchIndexesDif.get(condition.measureElementBranchIndex);
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                        else {
                            throw new Error('Unknown type of condition');
                        }
                    });
                    column.columnStyleDto.columnFormattingRule = new idm_report_export_service_client_js_1.ColumnFormattingRuleImpl(newFormattingConditions);
                    _this.reassignColumnFormattingConditionsMeasureBranchIndexes(column.children, branchIndexesDif);
                }
            }
        });
    };
    SisTabularReportOptionsComponent.prototype.changeFilter = function (isValid) {
        if (isValid) {
            this.stateChanged();
        }
    };
    SisTabularReportOptionsComponent.prototype.obtainSelectedRowNumberingEnabled = function () {
        if (this.isRowElementSelected) {
            this.isRowNumberingEnabled = this._rowView.rowCategoryStyleDto.numberingStyle !== null;
        }
    };
    var SisTabularReportOptionsComponent_1;
    __decorate([
        core_1.Input('state'),
        __metadata("design:type", String)
    ], SisTabularReportOptionsComponent.prototype, "fullState", void 0);
    __decorate([
        core_1.Output('stateChange'),
        __metadata("design:type", core_1.EventEmitter)
    ], SisTabularReportOptionsComponent.prototype, "viewState", void 0);
    SisTabularReportOptionsComponent = SisTabularReportOptionsComponent_1 = __decorate([
        core_1.Component({
            
            selector: 'sis-tabular-report-options',
            template: require('./sis-tabular-report-options.component.html'),
            styles: [require('./sis-tabular-report-options.component.css')],
            encapsulation: core_1.ViewEncapsulation.None
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: '<sis-tabular-report-options [state]=\'%{state}\' (stateChange)=\'%{stateChange}\'></sis-tabular-report-options>',
        }),
        __metadata("design:paramtypes", [view_event_service_1.ViewEventService,
            idm_dataset_service_client_js_1.DatasetService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_message_language_service_client_js_1.LanguageService,
            core_1.ChangeDetectorRef,
            store_1.Store,
            idm_kb_service_client_js_1.KbService,
            idm_locale_service_client_js_1.LocaleService])
    ], SisTabularReportOptionsComponent);
    return SisTabularReportOptionsComponent;
}());
exports.SisTabularReportOptionsComponent = SisTabularReportOptionsComponent;
//# sourceMappingURL=sis-tabular-report-options.component.js.map